module.exports = ([
    [ /“/g, "\"" ],
    [ /”/g, "\"" ],
    // 0. словарик
    // 0.1. слова на -аль
    // -иаль
    [ /ial/g, "иаль" ],
    [ /İAL/g, "ИАЛЬ" ],
    // актуаль
    [ /aktual/g, "актуаль" ],
    [ /Aktual/g, "Актуаль" ],
    [ /AKTUAL/g, "АКТУАЛЬ" ],
    // диагональ
    [ /diagonal/g, "диагональ" ],
    [ /Diagonal/g, "Диагональ" ],
    [ /DİAGONAL/g, "ДИАГОНАЛЬ" ],
    // эмсаль
    [ /emsal/g, "эмсаль" ],
    [ /Emsal/g, "Эмсаль" ],
    [ /EMSAL/g, "ЭМСАЛЬ" ],
    // фааль
    [ /faal/g, "фааль" ],
    [ /Faal/g, "Фааль" ],
    [ /FAAL/g, "ФААЛЬ" ],
    // феодаль
    [ /feodal/g, "феодаль" ],
    [ /Feodal/g, "Феодаль" ],
    [ /FEODAL/g, "ФЕОДАЛЬ" ],
    // горизонталь
    [ /gorizontal/g, "горизонталь" ],
    [ /Gorizontal/g, "Горизонталь" ],
    [ /GORİZONTAL/g, "ГОРИЗОНТАЛЬ" ],
    // документаль
    [ /dokumental/g, "документаль" ],
    [ /Dokumental/g, "Документаль" ],
    [ /DOKUMENTAL/g, "ДОКУМЕНТАЛЬ" ],
    // фестиваль
    [ /festival/g, "фестиваль" ],
    [ /Festival/g, "Фестиваль" ],
    [ /FESTİVAL/g, "ФЕСТИВАЛЬ" ],
    // хроникаль
    [ /hronikal/g, "хроникаль" ],
    [ /Hronikal/g, "Хроникаль" ],
    [ /HRONİKAL/g, "ХРОНИКАЛЬ" ],
    // идеаль
    [ /ideal/g, "идеаль" ],
    [ /İdeal/g, "Идеаль" ],
    [ /İDEAL/g, "ИДЕАЛЬ" ],
    // инструменталь
    [ /instrumental/g, "инструменталь" ],
    [ /İnstrumental/g, "Инструменталь" ],
    [ /İNSTRUMENTAL/g, "ИНСТРУМЕНТАЛЬ" ],
    // икъмаль
    [ /iqmal/g, "икъмаль" ],
    [ /İqmal/g, "Икъмаль" ],
    [ /İQMAL/g, "ИКЪМАЛЬ" ],
    // икъбаль
    [ /iqbal/g, "икъбаль" ],
    [ /İqbal/g, "Икъбаль" ],
    [ /İQBAL/g, "ИКЪБАЛЬ" ],
    // истикъбаль
    [ /istiqbal/g, "истикъбаль" ],
    [ /İstiqbal/g, "Истикъбаль" ],
    [ /İSTİQBAL/g, "ИСТИКЪБАЛЬ" ],
    // истикъляль
    [ /istiqlâl/g, "истикъляль" ],
    [ /İstiqlâl/g, "Истикъляль" ],
    [ /İSTİQLÂL/g, "ИСТИКЪЛЯЛЬ" ],
    // итъалят
    [ /([\s"'\(\)\-.,:;!?>\]/])italât/g, "$1итъалят" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])İtalât/g, "$1Итъалят" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])İTALÂT/g, "$1ИТЪАЛЯТ" ],
    // итъаль
    [ /([\s"'\(\)\-.,:;!?>\]/])ital/g, "$1итъаль" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])İtal/g, "$1Итъаль" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])İTAL/g, "$1ИТЪАЛЬ" ],
    // Италия
    [ /итъальiya/g, "италия" ],
    [ /Итъальiya/g, "Италия" ],
    [ /ИТЪАЛЬİYA/g, "ИТАЛИЯ" ],
    [ /итъальya/g, "италья" ],
    [ /Итъальya/g, "Италья" ],
    [ /ИТЪАЛЬYA/g, "ИТАЛЬЯ" ],
    // ишгъаль
    [ /işğal/g, "ишгъаль" ],
    [ /İşğal/g, "Ишгъаль" ],
    [ /İŞĞAL/g, "ИШГЪАЛЬ" ],
    // кафедраль
    [ /kafedral/g, "кафедраль" ],
    [ /Kafedral/g, "Кафедраль" ],
    [ /KAFEDRAL/g, "КАФЕДРАЛЬ" ],
    // казуаль
    [ /kazual/g, "казуаль" ],
    [ /Kazual/g, "Казуаль" ],
    [ /KAZUAL/g, "КАЗУАЛЬ" ],
    // коллегиаль
    [ /kollegial/g, "коллегиаль" ],
    [ /Kollegial/g, "Коллегиаль" ],
    [ /KOLLEGİAL/g, "КОЛЛЕГИАЛЬ" ],
    // колоссаль
    [ /kolossal/g, "колоссаль" ],
    [ /Kolossal/g, "Колоссаль" ],
    [ /KOLOSSAL/g, "КОЛОССАЛЬ" ],
    // коммуналь
    [ /kommunal/g, "коммуналь" ],
    [ /Kommunal/g, "Коммуналь" ],
    [ /KOMMUNAL/g, "КОММУНАЛЬ" ],
    // кардиналь
    [ /kardinal/g, "кардиналь" ],
    [ /Kardinal/g, "Кардиналь" ],
    [ /KARDİNAL/g, "КАРДИНАЛЬ" ],
    // криминаль
    [ /kriminal/g, "криминаль" ],
    [ /Kriminal/g, "Криминаль" ],
    [ /KRİMİNAL/g, "КРИМИНАЛЬ" ],
    // легаль
    [ /legal/g, "легаль" ],
    [ /Legal/g, "Легаль" ],
    [ /LEGAL/g, "ЛЕГАЛЬ" ],
    // леталь
    [ /letal/g, "леталь" ],
    [ /Letal/g, "Леталь" ],
    [ /LETAL/g, "ЛЕТАЛЬ" ],
    // либераль
    [ /liberal/g, "либераль" ],
    [ /Liberal/g, "Либераль" ],
    [ /LİBERAL/g, "ЛИБЕРАЛЬ" ],
    // локаль
    [ /lokal/g, "локаль" ],
    [ /Lokal/g, "Локаль" ],
    [ /LOKAL/g, "ЛОКАЛЬ" ],
    // мааль
    [ /maal([^e])/g, "мааль$1" ],
    [ /Maal([^e])/g, "Мааль$1" ],
    [ /MAAL([^E])/g, "МААЛЬ$1" ],
    // магистраль
    [ /magistral/g, "магистраль" ],
    [ /Magistral/g, "Магистраль" ],
    [ /MAGİSTRAL/g, "МАГИСТРАЛЬ" ],
    // материаль
    [ /material/g, "материаль" ],
    [ /Material/g, "Материаль" ],
    [ /MATERİAL/g, "МАТЕРИАЛЬ" ],
    // машиналь
    [ /maşinal/g, "машиналь" ],
    [ /Maşinal/g, "Машиналь" ],
    [ /MAŞİNAL/g, "МАШИНАЛЬ" ],
    // меаль
    [ /meal/g, "меаль" ],
    [ /Meal/g, "Меаль" ],
    [ /MEAL/g, "МЕАЛЬ" ],
    // медаль
    [ /medal/g, "медаль" ],
    [ /Medal/g, "Медаль" ],
    [ /MEDAL/g, "МЕДАЛЬ" ],
    // меридиональ
    [ /meridional/g, "меридиональ" ],
    [ /Meridional/g, "Меридиональ" ],
    [ /MERİDİONAL/g, "МЕРИДИОНАЛЬ" ],
    // мешъаль
    [ /meşal/g, "мешъаль" ],
    [ /Meşal/g, "Мешъаль" ],
    [ /MEŞAL/g, "МЕШЪАЛЬ" ],
    // минераль
    [ /mineral/g, "минераль" ],
    [ /Mineral/g, "Минераль" ],
    [ /MİNERAL/g, "МИНЕРАЛЬ" ],
    // минималь
    [ /minimal/g, "минималь" ],
    [ /Minimal/g, "Минималь" ],
    [ /MİNİMAL/g, "МИНИМАЛЬ" ],
    // мисаль
    [ /misal/g, "мисаль" ],
    [ /Misal/g, "Мисаль" ],
    [ /MİSAL/g, "МИСАЛЬ" ],
    // модаль
    [ /modal/g, "модаль" ],
    [ /Modal/g, "Модаль" ],
    [ /MODAL/g, "МОДАЛЬ" ],
    // музыкаль
    [ /muzıkal/g, "музыкаль" ],
    [ /Muzıkal/g, "Музыкаль" ],
    [ /MUZIKAL/g, "МУЗЫКАЛЬ" ],
    // номиналь
    [ /nominal/g, "номиналь" ],
    [ /Nominal/g, "Номиналь" ],
    [ /NOMİNAL/g, "НОМИНАЛЬ" ],
    // нормаль
    [ /normal/g, "нормаль" ],
    [ /Normal/g, "Нормаль" ],
    [ /NORMAL/g, "НОРМАЛЬ" ],
    // оптималь
    [ /optimal/g, "оптималь" ],
    [ /Optimal/g, "Оптималь" ],
    [ /OPTİMAL/g, "ОПТИМАЛЬ" ],
    // орбиталь
    [ /orbital/g, "орбиталь" ],
    [ /Orbital/g, "Орбиталь" ],
    [ /ORBİTAL/g, "ОРБИТАЛЬ" ],
    // оригиналь
    [ /original/g, "оригиналь" ],
    [ /Original/g, "Оригиналь" ],
    [ /ORİGİNAL/g, "ОРИГИНАЛЬ" ],
    // педаль
    [ /pedal/g, "педаль" ],
    [ /Pedal/g, "Педаль" ],
    [ /PEDAL/g, "ПЕДАЛЬ" ],
    // пропорциональ
    [ /proportsional/g, "пропорциональ" ],
    [ /Proportsional/g, "Пропорциональ" ],
    [ /PROPORTSİONAL/g, "ПРОПРОЦИОНАЛЬ" ],
    // профессиональ
    [ /professional/g, "профессиональ" ],
    [ /Professional/g, "Профессиональ" ],
    [ /PROFESSİONAL/g, "ПРОФЕССИОНАЛЬ" ],
    // радикаль
    [ /radikal/g, "радикаль" ],
    [ /Radikal/g, "Радикаль" ],
    [ /RADİKAL/g, "РАДИКАЛЬ" ],
    // рациональ
    [ /ratsional/g, "рациональ" ],
    [ /Ratsional/g, "Рациональ" ],
    [ /RATSİONAL/g, "РАЦИОНАЛЬ" ],
    // реаль
    [ /real/g, "реаль" ],
    [ /Real/g, "Реаль" ],
    [ /REAL/g, "РЕАЛЬ" ],
    // региональ
    [ /regional/g, "региональ" ],
    [ /Regional/g, "Региональ" ],
    [ /REGİONAL/g, "РЕГИОНАЛЬ" ],
    // суаль
    [ /sual/g, "суаль" ],
    [ /Sual/g, "Суаль" ],
    [ /SUAL/g, "СУАЛЬ" ],
    // шималь
    [ /şimal/g, "шималь" ],
    [ /Şimal/g, "Шималь" ],
    [ /ŞİMAL/g, "ШИМАЛЬ" ],
    // территориаль
    [ /territorial/g, "территориаль" ],
    [ /Territorial/g, "Территориаль" ],
    [ /TERRİTORİAL/g, "ТЕРРИТОРИАЛЬ" ],
    // тимсаль
    [ /timsal/g, "тимсаль" ],
    [ /Timsal/g, "Тимсаль" ],
    [ /TİMSAL/g, "ТИМСАЛЬ" ],
    // тоталь
    [ /total/g, "тоталь" ],
    [ /Total/g, "Тоталь" ],
    [ /TOTAL/g, "ТОТАЛЬ" ],
    // универсаль
    [ /universal/g, "универсаль" ],
    [ /Universal/g, "Универсаль" ],
    [ /UNİVERSAL/g, "УНИВЕРСАЛЬ" ],
    // уникаль
    [ /unikal/g, "уникаль" ],
    [ /Unikal/g, "Уникаль" ],
    [ /UNİKAL/g, "УНИКАЛЬ" ],
    // вертикаль
    [ /vertikal/g, "вертикаль" ],
    [ /Vertikal/g, "Вертикаль" ],
    [ /VERTİKAL/g, "ВЕРТИКАЛЬ" ],
    // виртуаль
    [ /virtual/g, "виртуаль" ],
    [ /Virtual/g, "Виртуаль" ],
    [ /VİRTUAL/g, "ВИРТУАЛЬ" ],
    // визуаль
    [ /vizual/g, "визуаль" ],
    [ /Vizual/g, "Визуаль" ],
    [ /VİZUAL/g, "ВИЗУАЛЬ" ],
    // вуаль
    [ /vual/g, "вуаль" ],
    [ /Vual/g, "Вуаль" ],
    [ /VUAL/g, "ВУАЛЬ" ],
    // зональ
    [ /zonal/g, "зональ" ],
    [ /Zonal/g, "Зональ" ],
    [ /ZONAL/g, "ЗОНАЛЬ" ],
    // зуаль
    [ /zual/g, "зуаль" ],
    [ /Zual/g, "Зуаль" ],
    [ /ZUAL/g, "ЗУАЛЬ" ],
    // слова с мягким знаком перед а, о, у, э
    // бильакис
    [ /bilakis/g, "бильакис" ],
    [ /Bilakis/g, "Бильакис" ],
    [ /BİLAKİS/g, "БИЛЬАКИС" ],
    // февкъульаде
    [ /fevqulade/g, "февкъульаде" ],
    [ /Fevqulade/g, "Февкъульаде" ],
    [ /FEVQULADE/g, "ФЕВКЪУЛЬАДЕ" ],
    [ /fevqulâde/g, "февкъульаде" ],
    [ /Fevqulâde/g, "Февкъульаде" ],
    [ /FEVQULÂDE/g, "ФЕВКЪУЛЬАДЕ" ],
    // маальэсеф
    [ /maalesef/g, "маальэсеф" ],
    [ /Maalesef/g, "Маальэсеф" ],
    [ /MAALESEF/g, "МААЛЬЭСЕФ" ],
    // мельэм
    [ /([\s"'\(\)\-.,:;!?>\]/])melem/g, "$1мельэм" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Melem/g, "$1Мельэм" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])MELEM/g, "$1МЕЛЬЭМ" ],
    // мельун
    [ /melun/g, "мельун" ],
    [ /Melun/g, "Мельун" ],
    [ /MELUN/g, "МЕЛЬУН" ],
    // вельасыл
    [ /velasıl/g, "вельасыл" ],
    [ /Velasıl/g, "Вельасыл" ],
    [ /VELASIL/g, "ВЕЛЬАСЫЛ" ],
    // ельаякъ
    [ /yelayaq/g, "ельаякъ" ],
    [ /Yelayaq/g, "Ельаякъ" ],
    [ /YELAYAQ/g, "ЕЛЬАЯКЪ" ],
    // другие слова с мягким знаком
    // альбатрос
    [ /albatros/g, "альбатрос" ],
    [ /Albatros/g, "Альбатрос" ],
    [ /ALBATROS/g, "АЛЬБАТРОС" ],
    // альбинос
    [ /albinos/g, "альбинос" ],
    [ /Albinos/g, "Альбинос" ],
    [ /ALBİNOS/g, "АЛЬБИНОС" ],
    // альбом
    [ /albom/g, "альбом" ],
    [ /Albom/g, "Альбом" ],
    [ /ALBOM/g, "АЛЬБОМ" ],
    // альбумин
    [ /albumin/g, "альбумин" ],
    [ /Albumin/g, "Альбумин" ],
    [ /ALBUMİN/g, "АЛЬБУМИН" ],
    // алфавит
    [ /alfavit/g, "алфавит" ],
    [ /Alfavit/g, "Алфавит" ],
    [ /ALFAVİT/g, "АЛФАВИТ" ],
    // альфа
    [ /alfa/g, "альфа" ],
    [ /Alfa/g, "Альфа" ],
    [ /ALFA/g, "АЛЬФА" ],
    // альманах
    [ /almanah/g, "альманах" ],
    [ /Almanah/g, "Альманах" ],
    [ /ALMANAH/g, "АЛЬМАНАХ" ],
    // альпинист
    [ /alpinist/g, "альпинист" ],
    [ /Alpinist/g, "Альпинист" ],
    [ /ALPİNİST/g, "АЛЬПИНИСТ" ],
    // альтерн
    [ /altern/g, "альтерн" ],
    [ /Altern/g, "Альтерн" ],
    [ /ALTERN/g, "АЛЬТЕРН" ],
    // альтру
    [ /altru/g, "альтру" ],
    [ /Altru/g, "Альтру" ],
    [ /ALTRU/g, "АЛЬТРУ" ],
    // альвеола
    [ /alveola/g, "альвеола" ],
    [ /Alveola/g, "Альвеола" ],
    [ /ALVEOLA/g, "АЛЬВЕОЛА" ],
    // ансамбль
    [ /ansambl/g, "ансамбль" ],
    [ /Ansambl/g, "Ансамбль" ],
    [ /ANSAMBL/g, "АНСАМБЛЬ" ],
    // ань
    [ /([\s"'\(\)\-.,:;!?>\]/])an([\s"'.,:;!?\)\-\[<])/g, "$1ань$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])An([\s"'.,:;!?\)\-\[<])/g, "$1Ань$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])AN([\s"'.,:;!?\)\-\[<])/g, "$1АНЬ$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ange([\s"'.,:;!?\)\-\[<])/g, "$1аньге$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ange([\s"'.,:;!?\)\-\[<])/g, "$1Аньге$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ANGE([\s"'.,:;!?\)\-\[<])/g, "$1АНЬГЕ$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ande([\s"'.,:;!?\)\-\[<])/g, "$1аньде$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ande([\s"'.,:;!?\)\-\[<])/g, "$1Аньде$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ANDE([\s"'.,:;!?\)\-\[<])/g, "$1АНЬДЕ$2" ],
    // аньане
    [ /anane/g, "аньане" ],
    [ /Anane/g, "Аньане" ],
    [ /ANANE/g, "АНЬАНЕ" ],
    // асфальт
    [ /asfalt/g, "асфальт" ],
    [ /Asfalt/g, "Асфальт" ],
    [ /ASFALT/g, "АСФАЛЬТ" ],
    // бальнео
    [ /balneo/g, "бальнео" ],
    [ /Balneo/g, "Бальнео" ],
    [ /BALNEO/g, "БАЛЬНЕО" ],
    // баарь
    [ /baar/g, "баарь" ],
    [ /Baar/g, "Баарь" ],
    [ /BAAR/g, "БААРЬ" ],
    // базальт
    [ /bazalt/g, "базальт" ],
    [ /Bazalt/g, "Базальт" ],
    [ /BAZALT/g, "БАЗАЛЬТ" ],
    // бинокль
    [ /binokl/g, "бинокль" ],
    [ /Binokl/g, "Бинокль" ],
    [ /BİNOKL/g, "БИНОКЛЬ" ],
    // большевик
    [ /bolşevik/g, "большевик" ],
    [ /Bolşevik/g, "Большевик" ],
    [ /BOLŞEVİK/g, "БОЛЬШЕВИК" ],
    // бульдозер
    [ /buldozer/g, "бульдозер" ],
    [ /Buldozer/g, "Бульдозер" ],
    [ /BULDOZER/g, "БУЛЬДОЗЕР" ],
    // бульон
    [ /bulyon/g, "бульон" ],
    [ /Bulyon/g, "Бульон" ],
    [ /BULYON/g, "БУЛЬОН" ],
    // бульвар
    [ /bulvar/g, "бульвар" ],
    [ /Bulvar/g, "Бульвар" ],
    [ /BULVAR/g, "БУЛЬВАР" ],
    // джурьат
    [ /curat/g, "джурьат" ],
    [ /Curat/g, "Джурьат" ],
    [ /CURAT/g, "ДЖУРЬАТ" ],
    [ /cürat/g, "джурьат" ],
    [ /Cürat/g, "Джурьат" ],
    [ /CÜRAT/g, "ДЖУРЬАТ" ],
    // девальв
    [ /devalv/g, "девальв" ],
    [ /Devalv/g, "Девальв" ],
    [ /DEVALV/g, "ДЕВАЛЬВ" ],
    // факульт
    [ /fakult/g, "факульт" ],
    [ /Fakult/g, "Факульт" ],
    [ /FAKULT/g, "ФАКУЛЬТ" ],
    // фальсиф
    [ /falsif/g, "фальсиф" ],
    [ /Falsif/g, "Фальсиф" ],
    [ /FALSİF/g, "ФАЛЬСИФ" ],
    // фольклор
    [ /folklor/g, "фольклор" ],
    [ /Folklor/g, "Фольклор" ],
    [ /FOLKLOR/g, "ФОЛЬКЛОР" ],
    // гальван
    [ /galvan/g, "гальван" ],
    [ /Galvan/g, "Гальван" ],
    [ /GALVAN/g, "ГАЛЬВАН" ],
    // геральд
    [ /gerald/g, "геральд" ],
    [ /Gerald/g, "Геральд" ],
    [ /GERALD/g, "ГЕРАЛЬД" ],
    // госпиталь
    [ /gospital/g, "госпиталь" ],
    [ /Gospital/g, "Госпиталь" ],
    [ /GOSPİTAL/g, "ГОСПИТАЛЬ" ],
    // женьшень
    [ /jenşen/g, "женьшень" ],
    [ /Jenşen/g, "Женьшень" ],
    [ /JENŞEN/g, "ЖЕНЬШЕНЬ" ],
    // инвентарь
    [ /inventar/g, "инвентарь" ],
    [ /İnventar/g, "Инвентарь" ],
    [ /İNVENTAR/g, "ИНВЕНТАРЬ" ],
    // кальк
    [ /kalk/g, "кальк" ],
    [ /Kalk/g, "Кальк" ],
    [ /KALK/g, "КАЛЬК" ],
    // кальмар
    [ /kalmar/g, "кальмар" ],
    [ /Kalmar/g, "Кальмар" ],
    [ /KALMAR/g, "КАЛЬМАР" ],
    // каньон
    [ /kanyon/g, "каньон" ],
    [ /Kanyon/g, "Каньон" ],
    [ /KANYON/g, "КАНЬОН" ],
    // коньки
    [ /konki/g, "коньки" ],
    [ /Konki/g, "Коньки" ],
    [ /KONKİ/g, "КОНЬКИ" ],
    // консульт
    [ /konsult/g, "консульт" ],
    [ /Konsult/g, "Консульт" ],
    [ /KONSULT/g, "КОНСУЛЬТ" ],
    // контроль
    [ /kontrol/g, "контроль" ],
    [ /Kontrol/g, "Контроль" ],
    [ /KONTROL/g, "КОНТРОЛЬ" ],
    // кульмин
    [ /kulmin/g, "кульмин" ],
    [ /Kulmin/g, "Кульмин" ],
    [ /KULMİN/g, "КУЛЬМИН" ],
    // культив
    [ /kultiv/g, "культив" ],
    [ /Kultiv/g, "Культив" ],
    [ /KULTİV/g, "КУЛЬТИВ" ],
    // культур
    [ /kultur/g, "культур" ],
    [ /Kultur/g, "Культур" ],
    [ /KULTUR/g, "КУЛЬТУР" ],
    // куфь
    [ /küf([^eü])/g, "куфь$1" ],
    [ /Küf([^eü])/g, "Куфь$1" ],
    [ /KÜF([^EÜ])/g, "КУФЬ$1" ],
    // лагерь
    [ /lager/g, "лагерь" ],
    [ /Lager/g, "Лагерь" ],
    [ /LAGER/g, "ЛАГЕРЬ" ],
    // макъбуль
    [ /maqbul/g, "макъбуль" ],
    [ /Maqbul/g, "Макъбуль" ],
    [ /MAQBUL/g, "МАКЪБУЛЬ" ],
    // макъуль
    [ /maqul/g, "макъуль" ],
    [ /Maqul/g, "Макъуль" ],
    [ /MAQUL/g, "МАКЪУЛЬ" ],
    // мальт
    [ /malt/g, "мальт" ],
    [ /Malt/g, "Мальт" ],
    [ /MALT/g, "МАЛЬТ" ],
    // мальземе
    [ /malzeme/g, "мальземе" ],
    [ /Malzeme/g, "Мальземе" ],
    [ /MALZEME/g, "МАЛЬЗЕМЕ" ],
    // меджуль
    [ /mecul/g, "меджуль" ],
    [ /Mecul/g, "Меджуль" ],
    [ /MECUL/g, "МЕДЖУЛЬ" ],
    // мешгъуль
    [ /meşğul/g, "мешгъуль" ],
    [ /Meşğul/g, "Мешгъуль" ],
    [ /MEŞĞUL/g, "МЕШГЪУЛЬ" ],
    // мульти
    [ /multi/g, "мульти" ],
    [ /Multi/g, "Мульти" ],
    [ /MULTİ/g, "МУЛЬТИ" ],
    // мусульман
    [ /musulman/g, "мусульман" ],
    [ /Musulman/g, "Мусульман" ],
    [ /MUSULMAN/g, "МУСУЛЬМАН" ],
    // нефть
    [ /neft/g, "нефть" ],
    [ /Neft/g, "Нефть" ],
    [ /NEFT/g, "НЕФТЬ" ],
    // нуль
    [ /nul([\s"'.,:;!?\)\-\[<dgn])/g, "нуль$1" ],
    [ /Nul([\s"'.,:;!?\)\-\[<dgn])/g, "Нуль$1" ],
    [ /NUL([\s"'.,:;!?\)\-\[<dgn])/g, "НУЛЬ$1" ],
    // пальто
    [ /palto/g, "пальто" ],
    [ /Palto/g, "Пальто" ],
    [ /PALTO/g, "ПАЛЬТО" ],
    // пальма
    [ /([\s"'\(\)\-.,:;!?>\]/])palma/g, "$1пальма" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Рalma/g, "$1Пальма" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])PALMA/g, "$1ПАЛЬМА" ],
    // пароль
    [ /parol/g, "пароль" ],
    [ /Рarol/g, "Пароль" ],
    [ /PAROL/g, "ПАРОЛЬ" ],
    // патруль
    [ /patrul/g, "патруль" ],
    [ /Рatrul/g, "Патруль" ],
    [ /PATRUL/g, "ПАТРУЛЬ" ],
    // пенальти
    [ /penalti/g, "пенальти" ],
    [ /Рenalti/g, "Пенальти" ],
    [ /PENALTİ/g, "ПЕНАЛЬТИ" ],
    // къальби
    [ /qalbi/g, "къальби" ],
    [ /Qalbi/g, "Къальби" ],
    [ /QALBİ/g, "КЪАЛЬБИ" ],
    // къальп
    [ /qalpke/g, "къальпке" ],
    [ /Qalpke/g, "Къальпке" ],
    [ /QALPKE/g, "КЪАЛЬПКЕ" ],
    [ /qalpler/g, "къальплер" ],
    [ /Qalpler/g, "Къальплер" ],
    [ /QALPLER/g, "КЪАЛЬПЛЕР" ],
    [ /qalpni/g, "къальпни" ],
    [ /Qalpni/g, "Къальпни" ],
    [ /QALPNİ/g, "КЪАЛЬПНИ" ],
    [ /qalpte/g, "къальпте" ],
    [ /Qalpte/g, "Къальпте" ],
    [ /QALPTE/g, "КЪАЛЬПТЕ" ],
    // къаарь
    [ /qaar/g, "къаарь" ],
    [ /Qaar/g, "Къаарь" ],
    [ /QAAR/g, "КЪААРЬ" ],
    // ресуль
    [ /resul/g, "ресуль" ],
    [ /Resul/g, "Ресуль" ],
    [ /RESUL/g, "РЕСУЛЬ" ],
    // рыцарь
    [ /rıtsar/g, "рыцарь" ],
    [ /Rıtsar/g, "Рыцарь" ],
    [ /RITSAR/g, "РЫЦАРЬ" ],
    // роль
    [ /([\s"'\(\)\-.,:;!?>\]/])rol([^ü])/g, "роль$1" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Rol([^ü])/g, "Роль$1" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ROL([^Ü])/g, "РОЛЬ$1" ],
    // рояль
    [ /royal/g, "рояль" ],
    [ /Royal/g, "Рояль" ],
    [ /ROYAL/g, "РОЯЛЬ" ],
    // саарь
    [ /saar/g, "саарь" ],
    [ /Saar/g, "Саарь" ],
    [ /SAAR/g, "СААРЬ" ],
    // спираль
    [ /spiral/g, "спираль" ],
    [ /Spiral/g, "Спираль" ],
    [ /SPİRAL/g, "СПИРАЛЬ" ],
    // сульх
    [ /sulh/g, "сульх" ],
    [ /Sulh/g, "Сульх" ],
    [ /SULH/g, "СУЛЬХ" ],
    // сумбуль
    [ /sumbul/g, "сумбуль" ],
    [ /Sumbul/g, "Сумбуль" ],
    [ /SUMBUL/g, "СУМБУЛЬ" ],
    // суньий
    [ /suniy/g, "суньий" ],
    [ /Suniy/g, "Суньий" ],
    [ /SUNİY/g, "СУНЬИЙ" ],
    // сурьат
    [ /([\s"'\(\)\-.,:;!?>\]/])surat/g, "$1сурьат" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Surat/g, "$1Сурьат" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])SURAT/g, "$1СУРЬАТ" ],
    // темаюль
    [ /temayul/g, "темаюль" ],
    [ /Temayul/g, "Темаюль" ],
    [ /TEMAYUL/g, "ТЕМАЮЛЬ" ],
    // усть
    [ /([\s"'\(\)\-.,:;!?>\]/])üst([^ü])/g, "$1усть$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Üst([^ü])/g, "$1Усть$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ÜST([^Ü])/g, "$1УСТЬ$2" ],
    // шальвар
    [ /şalvar/g, "шальвар" ],
    [ /Şalvar/g, "Шальвар" ],
    [ /ŞALVAR/g, "ШАЛЬВАР" ],
    // шампунь
    [ /şampun/g, "шампунь" ],
    [ /Şampun/g, "Шампунь" ],
    [ /ŞAMPUN/g, "ШАМПУНЬ" ],
    // ультимат
    [ /ultimat/g, "ультимат" ],
    [ /Ultimat/g, "Ультимат" ],
    [ /ULTİMAT/g, "УЛЬТИМАТ" ],
    // ультра
    [ /ultra/g, "ультра" ],
    [ /Ultra/g, "Ультра" ],
    [ /ULTRA/g, "УЛЬТРА" ],
    // вальс
    [ /vals/g, "вальс" ],
    [ /Vals/g, "Вальс" ],
    [ /VALS/g, "ВАЛЬС" ],
    // вальц
    [ /valts/g, "вальц" ],
    [ /Valts/g, "Вальц" ],
    [ /VALTS/g, "ВАЛЬЦ" ],
    // ведомость
    [ /vedomost/g, "ведомость" ],
    [ /Vedomost/g, "Ведомость" ],
    [ /VEDOMOST/g, "ВЕДОМОСТЬ" ],
    // зулькъарнейн
    [ /zulqarneyn/g, "зулькъарнейн" ],
    [ /Zulqarneyn/g, "Зулькъарнейн" ],
    [ /ZULQARNEYN/g, "ЗУЛЬКЪАРНЕЙН" ],
    // январь
    [ /yanvar/g, "январь" ],
    [ /Yanvar/g, "Январь" ],
    [ /YANVAR/g, "ЯНВАРЬ" ],
    // февраль
    [ /fevral/g, "февраль" ],
    [ /Fevral/g, "Февраль" ],
    [ /FEVRAL/g, "ФЕВРАЛЬ" ],
    // июнь
    [ /iyün/g, "июнь" ],
    [ /İyün/g, "Июнь" ],
    [ /İYÜN/g, "ИЮНЬ" ],
    // сентябрь
    [ /sentâbr/g, "сентябрь" ],
    [ /Sentâbr/g, "Сентябрь" ],
    [ /SENTÂBR/g, "СЕНТЯБРЬ" ],
    // октябрь
    [ /oktâbr/g, "октябрь" ],
    [ /Oktâbr/g, "Октябрь" ],
    [ /OKTÂBR/g, "ОКТЯБРЬ" ],
    // ноябрь
    [ /noyabr/g, "ноябрь" ],
    [ /Noyabr/g, "Ноябрь" ],
    [ /NOYABR/g, "НОЯБРЬ" ],
    // декабрь
    [ /dekabr/g, "декабрь" ],
    [ /Dekabr/g, "Декабрь" ],
    [ /DEKABR/g, "ДЕКАБРЬ" ],
    // слова с твёрдым знаком
    // бидъат
    [ /bidat/g, "бидъат" ],
    [ /Bidat/g, "Бидъат" ],
    [ /BİDAT/g, "БИДЪАТ" ],
    // бузъюрек
    [ /buzyürek/g, "бузъюрек" ],
    [ /Buzyürek/g, "Бузъюрек" ],
    [ /BUZYÜREK/g, "БУЗЪЮРЕК" ],
    // атешъюрек
    [ /ateşyürek/g, "атешъюрек" ],
    [ /Ateşyürek/g, "Атешъюрек" ],
    [ /ATEŞYÜREK/g, "АТЕШЪЮРЕК" ],
    // алъянакъ
    [ /alyanaq/g, "алъянакъ" ],
    [ /Alyanaq/g, "Алъянакъ" ],
    [ /ALYANAQ/g, "АЛЪЯНАКЪ" ],
    // демиръёл
    [ /demiryol/g, "демиръёл" ],
    [ /Demiryol/g, "Демиръёл" ],
    [ /DEMİRYOL/g, "ДЕМИРЪЁЛ" ],
    // деръал
    [ /([\s"'\(\)\-.,:;!?>\]/])deral/g, "$1деръал" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Deral/g, "$1Деръал" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])DERAL/g, "$1ДЕРЪАЛ" ],
    // инъекц
    [ /inyekts/g, "инъекц" ],
    [ /İnyekts/g, "Инъекц" ],
    [ /İNYEKTS/g, "ИНЪЕКЦ" ],
    // конъюктура
    [ /konyuktur/g, "конъюктур" ],
    [ /Konyuktur/g, "Конъюктур" ],
    [ /KONYUKTUR/g, "КОНЪЮКТУР" ],
    // мефъум
    [ /mefum/g, "мефъум" ],
    [ /Mefum/g, "Мефъум" ],
    [ /MEFUM/g, "МЕФЪУМ" ],
    // мешъум
    [ /meşum/g, "мешъум" ],
    [ /Meşum/g, "Мешъум" ],
    [ /MEŞUM/g, "МЕШЪУМ" ],
    // объект
    [ /obyekt/g, "объект" ],
    [ /Obyekt/g, "Объект" ],
    [ /OBYEKT/g, "ОБЪЕКТ" ],
    // разъезд
    [ /razyezd/g, "разъезд" ],
    [ /Razyezd/g, "Разъезд" ],
    [ /RAZYEZD/g, "РАЗЪЕЗД" ],
    // субъект
    [ /subyekt/g, "субъект" ],
    [ /Subyekt/g, "Субъект" ],
    [ /SUBYEKT/g, "СУБЪЕКТ" ],
    // хавъяр
    [ /havyar/g, "хавъяр" ],
    [ /Havyar/g, "Хавъяр" ],
    [ /HAVYAR/g, "ХАВЪЯР" ],
    // ямъям
    [ /yamyam/g, "ямъям" ],
    [ /Yamyam/g, "Ямъям" ],
    [ /YAMYAM/g, "ЯМЪЯМ" ],
    // слова с буквой щ
    // ящик
    [ /yaşçik/g, "ящик" ],
    [ /Yaşçik/g, "Ящик" ],
    [ /YAŞÇİK/g, "ЯЩИК" ],
    // мещан
    [ /meşçan/g, "мещан" ],
    [ /Meşçan/g, "Мещан" ],
    [ /MEŞÇAN/g, "МЕЩАН" ],
    // слова с буквой ц
    // акциз
    [ /aktsiz/g, "акциз" ],
    [ /Aktsiz/g, "Акциз" ],
    [ /AKTSİZ/g, "АКЦИЗ" ],
    // ацет
    [ /atset/g, "ацет" ],
    [ /Atset/g, "Ацет" ],
    [ /ATSET/g, "АЦЕТ" ],
    // блиц
    [ /blits/g, "блиц" ],
    [ /Blits/g, "Блиц" ],
    [ /BLİTS/g, "БЛИЦ" ],
    // бруцеллёз
    [ /brutsellöz/g, "бруцеллёз" ],
    [ /Brutsellöz/g, "Бруцеллёз" ],
    [ /BRUTSELLÖZ/g, "БРУЦЕЛЛЁЗ" ],
    // доцент
    [ /dotsent/g, "доцент" ],
    [ /Dotsent/g, "Доцент" ],
    [ /DOTSENT/g, "ДОЦЕНТ" ],
    // фармацевт
    [ /farmatsevt/g, "фармацевт" ],
    [ /Farmatsevt/g, "Фармацевт" ],
    [ /FARMATSEVT/g, "ФАРМАЦЕВТ" ],
    // глицер
    [ /glitser/g, "глицер" ],
    [ /Glitser/g, "Глицер" ],
    [ /GLİTSER/g, "ГЛИЦЕР" ],
    // лицей
    [ /litsey/g, "лицей" ],
    [ /Litsey/g, "Лицей" ],
    [ /LİTSEY/g, "ЛИЦЕЙ" ],
    // люцерна
    [ /lütserna/g, "люцерна" ],
    [ /Lütserna/g, "Люцерна" ],
    [ /LÜTSERNA/g, "ЛЮЦЕРНА" ],
    // меццо
    [ /metstso/g, "меццо" ],
    [ /Metstso/g, "Меццо" ],
    [ /METSTSO/g, "МЕЦЦО" ],
    // мефкуре
    [ /mefküre/g, "мефкуре" ],
    [ /Mefküre/g, "Мефкуре" ],
    [ /MEFKÜRE/g, "МЕФКУРЕ" ],
    // нацизм
    [ /natsi/g, "наци" ],
    [ /Natsi/g, "Наци" ],
    [ /NATSİ/g, "НАЦИ" ],
    // офицер
    [ /ofitser/g, "офицер" ],
    [ /Ofitser/g, "Офицер" ],
    [ /OFİTSER/g, "ОФИЦЕР" ],
    // проце
    [ /protse/g, "проце" ],
    [ /Protse/g, "Проце" ],
    [ /PROTSE/g, "ПРОЦЕ" ],
    // реценз
    [ /retsenz/g, "реценз" ],
    [ /Retsenz/g, "Реценз" ],
    [ /RETSENZ/g, "РЕЦЕНЗ" ],
    // рецеп
    [ /retsep/g, "рецеп" ],
    [ /Retsep/g, "Рецеп" ],
    [ /RETSEP/g, "РЕЦЕП" ],
    // теплица
    [ /teplitsa/g, "теплица" ],
    [ /Teplitsa/g, "Теплица" ],
    [ /TEPLİTSA/g, "ТЕПЛИЦА" ],
    // вице
    [ /vitse/g, "вице" ],
    [ /Vitse/g, "Вице" ],
    [ /VİTSE/g, "ВИЦЕ" ],
    // цепс
    [ /tseps/g, "цепс" ],
    [ /TSEPS/g, "ЦЕПС" ],
    // швейцар
    [ /şveytsar/g, "швейцар" ],
    [ /Şveytsar/g, "Швейцар" ],
    [ /ŞVEYTSAR/g, "ШВЕЙЦАР" ],
    // слова без буквы ц (повелит. наклонение на -тсин)
    // агъартсын
    [ /ağarts/g, "агъартс" ],
    [ /Ağarts/g, "Агъартс" ],
    [ /AĞARTS/g, "АГЪАРТС" ],
    // агъыртсын
    [ /ağırts/g, "агъыртс" ],
    [ /Ağırts/g, "Агъыртс" ],
    [ /AĞIRTS/g, "АГЪЫРТС" ],
    // бильдиртсин
    [ /bildirts/g, "бильдиртс" ],
    [ /Bildirts/g, "Бильдиртс" ],
    [ /BİLDİRTS/g, "БИЛЬДИРТС" ],
    // битсин
    [ /bitsin/g, "битсин" ],
    [ /Bitsin/g, "Битсин" ],
    [ /BİTSİN/g, "БИТСИН" ],
    // буюльтсин
    [ /büyülts/g, "буюльтс" ],
    [ /Büyülts/g, "Буюльтс" ],
    [ /BÜYÜLTS/g, "БУЮЛЬТС" ],
    // буютсин
    [ /büyüts/g, "буютс" ],
    [ /Büyüts/g, "Буютс" ],
    [ /BÜYÜTS/g, "БУЮТС" ],
    // гебертс
    [ /geberts/g, "гебертс" ],
    [ /Geberts/g, "Гебертс" ],
    [ /GEBERTS/g, "ГЕБЕРТС" ],
    // делиртсин
    [ /delirts/g, "делиртс" ],
    [ /Delirts/g, "Делиртс" ],
    [ /DELİRTS/g, "ДЕЛИРТС" ],
    // эгрильтсин
    [ /egrilts/g, "эгрильтс" ],
    [ /Egrilts/g, "Эгрильтс" ],
    [ /EGRİLTS/g, "ЭГРИЛЬТС" ],
    // эксильтсин
    [ /eksilts/g, "эксильтс" ],
    [ /Eksilts/g, "Эксильтс" ],
    [ /EKSİLTS/g, "ЭКСИЛЬТС" ],
    // эшитсин
    [ /eşits/g, "эшитс" ],
    [ /Eşits/g, "Эшитс" ],
    [ /EŞİTS/g, "ЭШИТС" ],
    // иритсин
    [ /irits/g, "иритс" ],
    [ /İrits/g, "Иритс" ],
    [ /İRİTS/g, "ИРИТС" ],
    // иситсин
    [ /isits/g, "иситс" ],
    [ /İsits/g, "Иситс" ],
    [ /İSİTS/g, "ИСИТС" ],
    // ичиртсин
    [ /içirts/g, "ичиртс" ],
    [ /İçirts/g, "Ичиртс" ],
    [ /İÇİRTS/g, "ИЧИРТС" ],
    // кертсин
    [ /kertsin/g, "кертсин" ],
    [ /Kertsin/g, "Кертсин" ],
    [ /KERTSİN/g, "КЕРТСИН" ],
    // кенишлетсин
    [ /kenişlets/g, "кенишлетс" ],
    [ /Kenişlets/g, "Кенишлетс" ],
    [ /KENİŞLETS/g, "КЕНИШЛЕТС" ],
    // кийсетсин
    [ /kiysets/g, "кийсетс" ],
    [ /Kiysets/g, "Кийсетс" ],
    [ /KİYSETS/g, "КИЙСЕТС" ],
    // копюртсин
    [ /köpürts/g, "копюртс" ],
    [ /Köpürts/g, "Копюртс" ],
    [ /KÖPÜRTS/g, "КОПЮРТС" ],
    // косьтертсин
    [ /kösterts/g, "косьтертс" ],
    [ /Kösterts/g, "Косьтертс" ],
    [ /KÖSTERTS/g, "КОСЬТЕРТС" ],
    // кучертсин
    [ /küçerts/g, "кучертс" ],
    [ /Küçerts/g, "Кучертс" ],
    [ /KÜÇERTS/g, "КУЧЕРТС" ],
    // кучюльтсин
    [ /küçülts/g, "кучюльтс" ],
    [ /Küçülts/g, "Кучюльтс" ],
    [ /KÜÇÜLTS/g, "КУЧЮЛЬТС" ],
    // пертсин
    [ /pertsin/g, "пертсин" ],
    [ /Pertsin/g, "Пертсин" ],
    [ /PERTSİN/g, "ПЕРТСИН" ],
    // къайтсын
    [ /qayts/g, "къайтс" ],
    [ /Qayts/g, "Къайтс" ],
    [ /QAYTS/g, "КЪАЙТС" ],
    // отьсин
    [ /öts/g, "отьс" ],
    [ /Öts/g, "Отьс" ],
    [ /ÖTS/g, "ОТЬС" ],
    // орьтсин
    [ /örts/g, "орьтс" ],
    [ /Örts/g, "Орьтс" ],
    [ /ÖRTS/g, "ОРЬТС" ],
    // тартсын
    [ /tarts/g, "тартс" ],
    [ /Tarts/g, "Тартс" ],
    [ /TARTS/g, "ТАРТС" ],
    // тутсун
    [ /tutsun/g, "тутсун" ],
    [ /Tutsun/g, "Тутсун" ],
    [ /TUTSUN/g, "ТУТСУН" ],
    // тюнъюльтсин
    [ /tüñülts/g, "тюнъюльтс" ],
    [ /Tüñülts/g, "Тюнъюльтс" ],
    [ /TÜÑÜLTS/g, "ТЮНЪЮЛЬТС" ],
    // тюртсин
    [ /türts/g, "тюртс" ],
    [ /Türts/g, "Тюртс" ],
    [ /TÜRTS/g, "ТЮРТС" ],
    // янъартсын
    [ /yañarts/g, "янъартс" ],
    [ /Yañarts/g, "Янъартс" ],
    [ /YAÑARTS/g, "ЯНЪАРТС" ],
    // ебертсин
    [ /yeberts/g, "ебертс" ],
    [ /Yeberts/g, "Ебертс" ],
    [ /YEBERTS/g, "ЕБЕРТС" ],
    // етсин
    [ /yetsin/g, "етсин" ],
    [ /Yetsin/g, "Етсин" ],
    [ /YETSİN/g, "ЕТСИН" ],
    // ешертсин
    [ /yeşerts/g, "ешертс" ],
    [ /Yeşerts/g, "Ешертс" ],
    [ /YEŞERTS/g, "ЕШЕРТС" ],
    // йиритсин
    [ /yirits/g, "йиритс" ],
    [ /Yirits/g, "Йиритс" ],
    [ /YİRİTS/g, "ЙИРИТС" ],
    // этсин
    [ /([\s"'\(\)\-.,:;!?>\]/])etsin/g, "$1этсин" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Etsin/g, "$1Этсин" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ETSİN/g, "$1ЭТСИН" ],
    // -етсин
    [ /etsin/g, "етсин" ],
    [ /ETSİN/g, "ЕТСИН" ],
    // къутсуз
    [ /qutsuz/g, "къутсуз" ],
    [ /Qutsuz/g, "Къутсуз" ],
    [ /QUTSUZ/g, "КЪУТСУЗ" ],
    // разные исключения
    // алейкум
    [ /aleyküm/g, "алейкум" ],
    [ /Aleyküm/g, "Алейкум" ],
    [ /ALEYKÜM/g, "АЛЕЙКУМ" ],
    // бейуде
    [ /beyüde/g, "бейуде" ],
    [ /Beyüde/g, "Бейуде" ],
    [ /BEYÜDE/g, "БЕЙУДЕ" ],
    [ /beyude/g, "бейуде" ],
    [ /Beyude/g, "Бейуде" ],
    [ /BEYUDE/g, "БЕЙУДЕ" ],
    // бугунь
    [ /bugün/g, "бугунь" ],
    [ /Bugün/g, "Бугунь" ],
    [ /BUGÜN/g, "БУГУНЬ" ],
    // бюджет
    [ /bücet/g, "бюджет" ],
    [ /Bücet/g, "Бюджет" ],
    [ /BÜCET/g, "БЮДЖЕТ" ],
    // бульбуль
    [ /bülbül/g, "бульбуль" ],
    [ /Bülbül/g, "Бульбуль" ],
    [ /BÜLBÜL/g, "БУЛЬБУЛЬ" ],
    // бюллет
    [ /büllet/g, "бюллет" ],
    [ /Büllet/g, "Бюллет" ],
    [ /BÜLLET/g, "БЮЛЛЕТ" ],
    // бюро
    [ /büro/g, "бюро" ],
    [ /Büro/g, "Бюро" ],
    [ /BÜRO/g, "БЮРО" ],
    // бус-бутюн
    [ /büs-bütün/g, "бус-бутюн" ],
    [ /Büs-bütün/g, "Бус-бутюн" ],
    [ /BÜS-BÜTÜN/g, "БУС-БУТЮН" ],
    // бюст
    [ /büst/g, "бюст" ],
    [ /Büst/g, "Бюст" ],
    [ /BÜST/g, "БЮСТ" ],
    // вакъиалар
    [ /vaqиаль/g, "вакъиал" ],
    [ /Vaqиаль/g, "Вакъиал" ],
    [ /VAQИАЛЬ/g, "ВАКЪИАЛ" ],
    // гонъюль
    [ /göñül/g, "гонъюль" ],
    [ /GÖÑÜL/g, "ГОНЪЮЛЬ" ],
    // гургуль
    [ /gürgül/g, "гургуль" ],
    [ /Gürgül/g, "Гургуль" ],
    [ /GÜRGÜL/g, "ГУРГУЛЬ" ],
    // джонк
    [ /cönk/g, "джонк" ],
    [ /Cönk/g, "Джонк" ],
    [ /CÖNK/g, "ДЖОНК" ],
    // джуньджу
    [ /cüncü/g, "джуньджу" ],
    [ /Cüncü/g, "Джуньджу" ],
    [ /CÜNCÜ/g, "ДЖУНЬДЖУ" ],
    // диалог
    [ /dиальog/g, "диалог" ],
    [ /Dиальog/g, "Диалог" ],
    [ /DИАЛЬOG/g, "ДИАЛОГ" ],
    // зумбуль
    [ /zümbül/g, "зумбуль" ],
    [ /Zümbül/g, "Зумбуль" ],
    [ /ZÜMBÜL/g, "ЗУМБУЛЬ" ],
    // йод
    [ /([\s"'\(\)\-.,:;!?>\]/])yod/g, "$1йод" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Yod/g, "$1Йод" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])YOD/g, "$1ЙОД" ],
    // кёр
    [ /([\s"'\(\)\-.,:;!?>\]/])kör([\s"'.,:;!?\)\-\[<])/g, "$1кёр$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Kör([\s"'.,:;!?\)\-\[<])/g, "$1Кёр$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])KÖR([\s"'.,:;!?\)\-\[<])/g, "$1КЁР$2" ],
    // койот
    [ /koyot/g, "койот" ],
    [ /Koyot/g, "Койот" ],
    [ /KOYOT/g, "КОЙОТ" ],
    // кёрджа
    [ /körca/g, "кёрджа" ],
    [ /Körca/g, "Кёрджа" ],
    [ /KÖRCA/g, "КЁРДЖА" ],
    // кирил
    [ /kiril/g, "кирил" ],
    [ /Kiril/g, "Кирил" ],
    [ /KİRİL/g, "КИРИЛ" ],
    // конвейер
    [ /kоnveyer/g, "конвейер" ],
    [ /Kоnveyer/g, "Конвейер" ],
    [ /KONVEYER/g, "КОНВЕЙЕР" ],
    // коше
    [ /köşe/g, "коше" ],
    [ /Köşe/g, "Коше" ],
    [ /KÖŞE/g, "КОШЕ" ],
    // кой
    [ /köy/g, "коy" ],
    [ /Köy/g, "Коy" ],
    [ /KÖY/g, "КОY" ],
    // козь
    [ /köz([^üe])/g, "козь$1" ],
    [ /Köz([^üe])/g, "Козь$1" ],
    [ /KÖZ([^Üe])/g, "КОЗЬ$1" ],
    // кушку
    [ /küşkü/g, "кушку" ],
    [ /Küşkü/g, "Кушку" ],
    [ /KÜŞKÜ/g, "КУШКУ" ],
    // кулеръюзь
    [ /küleryüz/g, "кулеръюзь" ],
    [ /Küleryüz/g, "Кулеръюзь" ],
    [ /KÜLERYÜZ/g, "КУЛЕРЪЮЗЬ" ],
    // маалле
    [ /маальle/g, "маалле" ],
    [ /Маальle/g, "Маалле" ],
    [ /МААЛЬLE/g, "МААЛЛЕ" ],
    // майор
    [ /mayor/g, "майор" ],
    [ /Mayor/g, "Майор" ],
    [ /MAYOR/g, "МАЙОР" ],
    // маниалар
    [ /manиаль/g, "маниал" ],
    [ /Manиаль/g, "Маниал" ],
    [ /MANИАЛЬ/g, "МАНИАЛ" ],
    // месуль
    [ /mesül/g, "месуль" ],
    [ /Mesül/g, "Месуль" ],
    [ /MESÜL/g, "МЕСУЛЬ" ],
    [ /mesul/g, "месуль" ],
    [ /Mesul/g, "Месуль" ],
    [ /MESUL/g, "МЕСУЛЬ" ],
    // мевджут
    [ /mevcü/g, "мевджу" ],
    [ /Mevcü/g, "Мевджу" ],
    [ /MEVCÜ/g, "МЕВДЖУ" ],
    // муурь
    [ /müür/g, "муурь" ],
    [ /Müür/g, "Муурь" ],
    [ /MÜÜR/g, "МУУРЬ" ],
    // мэр
    [ /([\s"'\(\)\-.,:;!?>\]/])mer([i\s"'.,:;!?\)\-\[<])/g, "$1мэр$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Mer([i\s"'.,:;!?\)\-\[<])/g, "$1Мэр$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])MER([İ\s"'.,:;!?\)\-\[<])/g, "$1МЭР$2" ],
    // меридиан
    [ /мэридиан/g, "меридиан" ],
    [ /Мэридиан/g, "Меридиан" ],
    [ /МЭРИДИАН/g, "МЕРИДИАН" ],
    // нормалар
    [ /нормальa/g, "нормала" ],
    [ /Нормальa/g, "Нормала" ],
    [ /НОРМАЛЬA/g, "НОРМАЛА" ],
    // нумюне
    [ /nümüne/g, "нумюне" ],
    [ /Nümüne/g, "Нумюне" ],
    [ /NÜMÜNE/g, "НУМЮНЕ" ],
    // ольчер
    [ /ölçer/g, "ольчер" ],
    [ /ÖLÇER/g, "ОЛЬЧЕР" ],
    // проект
    [ /proekt/g, "проект" ],
    [ /Proekt/g, "Проект" ],
    [ /PROEKT/g, "ПРОЕКТ" ],
    // район
    [ /rayon/g, "район" ],
    [ /Rayon/g, "Район" ],
    [ /RAYON/g, "РАЙОН" ],
    // сойады
    [ /soyadı/g, "сойады" ],
    [ /Soyadı/g, "Сойады" ],
    [ /SOYADI/g, "СОЙАДЫ" ],
    // спортсмен
    [ /sportsmen/g, "спортсмен" ],
    [ /Sportsmen/g, "Спортсмен" ],
    [ /SPORTSMEN/g, "СПОРТСМЕН" ],
    // сурет
    [ /süret/g, "сурет" ],
    [ /Süret/g, "Сурет" ],
    [ /SÜRET/g, "СУРЕТ" ],
    // сурет
    [ /hanımefendi/g, "ханымэфенди" ],
    [ /Hanımefendi/g, "Ханымэфенди" ],
    [ /HANIMEFENDİ/g, "ХАНЫМЭФЕНДИ" ],
    // услюп
    [ /([\s"'\(\)\-.,:;!?>\]/])üslü/g, "$1услю" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Üslü/g, "$1Услю" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ÜSLÜ/g, "$1УСЛЮ" ],
    // эгуль
    [ /([\s"'\(\)\-.,:;!?>\]/])egül/g, "$1эгуль" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Egül/g, "$1Эгуль" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])EGÜL/g, "$1ЭГУЛЬ" ],
    // юзбашы
    [ /([\s"'\(\)\-.,:;!?>\]/])yüzbaşı/g, "$1юзбашы" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Yüzbaşı/g, "$1Юзбашы" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])YÜZBAŞI/g, "$1ЮЗБАШЫ" ],
    // юзйыллыкъ
    [ /([\s"'\(\)\-.,:;!?>\]/])yüzyıl/g, "$1юзйыл" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Yüzyıl/g, "$1Юзйыл" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])YÜZYIL/g, "$1ЮЗЙЫЛ" ],
    // 3-юнджи, 4-юнджи
    [ /([34])-ünci/g, "$1-юнджи" ],
    [ /([34])-ÜNCİ/g, "$1-юнджи" ],
    // имена собственные
    // Альберт
    [ /Albert/g, "Альберт" ],
    [ /ALBERT/g, "АЛЬБЕРТ" ],
    // Ботсвана
    [ /Botsvana/g, "Ботсвана" ],
    [ /BOTSVANA/g, "БОТСВАНА" ],
    // Гайана
    [ /Gayana/g, "Гайана" ],
    [ /GAYANA/g, "ГАЙАНА" ],
    // Гриц
    [ /Grits/g, "Гриц" ],
    [ /GRİTS/g, "ГРИЦ" ],
    // гурджи
    [ /gürci/g, "гурджи" ],
    [ /Gürci/g, "Гурджи" ],
    [ /GÜRCİ/g, "ГУРДЖИ" ],
    // Эмирусеин
    [ /Emirüsein/g, "Эмирусеин" ],
    [ /EMİRÜSEİN/g, "ЭМИРУСЕИН" ],
    // -флотский
    [ /flotsk/g, "флотск" ],
    [ /Flotsk/g, "Флотск" ],
    [ /FLOTSK/g, "ФЛОТСК" ],
    // Игорь
    [ /İgor/g, "Игорь" ],
    [ /İGOR/g, "ИГОРЬ" ],
    // Исмаил
    [ /ismail/g, "исмаил" ],
    [ /İsmail/g, "Исмаил" ],
    [ /İSMAİL/g, "ИСМАИЛ" ],
    // (Сент-)Киттс
    [ /([\s"'\(\)\-.,:;!?>\]/])Kitts/g, "$1Киттс" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])KİTTS/g, "$1КИТТС" ],
    // Корбекуль
    [ /Körbekülü/g, "Корбекулю" ],
    [ /KÖRBEKÜLÜ/g, "КОРБЕКУЛЮ" ],
    [ /Körbekül/g, "Корбекуль" ],
    [ /KÖRBEKÜL/g, "КОРБЕКУЛЬ" ],
    // Куницин
    [ /Kunitsın/g, "Куницын" ],
    [ /KUNİTSIN/g, "КУНИЦЫН" ],
    // Львив
    [ /([\s"'\(\)\-.,:;!?>\]/])Lviv/g, "$1Львив" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])LVİV/g, "$1ЛЬВИВ" ],
    // Львов
    [ /([\s"'\(\)\-.,:;!?>\]/])Lvov/g, "$1Львов" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])LVOV/g, "$1ЛЬВОВ" ],
    // Къуртсейит
    [ /Qurtseyit/g, "Къуртсейит" ],
    [ /QURTSEYİT/g, "КЪУРТСЕЙИТ" ],
    // Къуртсеит
    [ /Qurtseit/g, "Къуртсеит" ],
    [ /QURTSEİT/g, "КЪУРТСЕИТ" ],
    // Къуртумер
    [ /Qurtümer/g, "Къуртумер" ],
    [ /QURTÜMER/g, "КЪУРТУМЕР" ],
    // Мариуполь
    [ /Mariupol/g, "Мариуполь" ],
    [ /MARİUPOL/g, "МАРИУПОЛЬ" ],
    // Марьино
    [ /Maryino/g, "Марьино" ],
    [ /MARYİNO/g, "МАРЬИНО" ],
    // Мустеджип
    [ /Müsteci/g, "Мустеджи" ],
    [ /MÜSTECİ/g, "МУСТЕДЖИ" ],
    // Павел
    [ /([\s"'\(\)\-.,:;!?>\]/])Pavel/g, "$1Павел" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])PAVEL/g, "$1ПАВЕЛ" ],
    // Сеитумер
    [ /Seitümer/g, "Сеитумер" ],
    [ /SEİTÜMER/g, "СЕИТУМЕР" ],
    // Сеитусеин
    [ /Seitüsein/g, "Сеитусеин" ],
    [ /SEİTÜSEİN/g, "СЕИТУСЕИН" ],
    // Сейитумер
    [ /Seyitümer/g, "Сейитумер" ],
    [ /SEYİTÜMER/g, "СЕЙИТУМЕР" ],
    // Сейитусеин
    [ /Seyitüsein/g, "Сейитусеин" ],
    [ /SEYİTÜSEİN/g, "СЕЙИТУСЕИН" ],
    // Сейитусейин
    [ /Seyitüseyin/g, "Сейитусейин" ],
    [ /SEYİTÜSEYİN/g, "СЕЙИТУСЕЙИН" ],
    // Смаил
    [ /smail/g, "смаил" ],
    [ /Smail/g, "Смаил" ],
    [ /SMAİL/g, "СМАИЛ" ],
    // Советский
    [ /sovetsk/g, "советск" ],
    [ /Sovetsk/g, "Советск" ],
    [ /SOVETSK/g, "СОВЕТСК" ],
    // Шемьи-заде
    [ /şemi-zade/g, "шемьи-заде" ],
    [ /Şemi-zade/g, "Шемьи-заде" ],
    [ /ŞEMİ-ZADE/g, "ШЕМЬИ-ЗАДЕ" ],
    // йохан
    [ /Yohan/g, "Йохан" ],
    [ /YOHAN/g, "ЙОХАН" ],
    // йорк
    [ /York/g, "Йорк" ],
    [ /YORK/g, "ЙОРК" ],
    // ющенко
    [ /yuşçenko/g, "ющенко" ],
    [ /Yuşçenko/g, "Ющенко" ],
    [ /YUŞÇENKO/g, "ЮЩЕНКО" ],
    // зайц-
    [ /zayts/g, "зайц" ],
    [ /Zayts/g, "Зайц" ],
    [ /ZAYTS/g, "ЗАЙЦ" ],
    // -ополь
    [ /([^\s])opol/g, "$1ополь" ],
    [ /([^\s])OPOL/g, "$1ОПОЛЬ" ],
    // -льное
    [ /([^\s])lnoye/g, "$1льное" ],
    [ /([^\s])LNOYE/g, "$1ЛЬНОЕ" ],
    // -льный
    [ /([^\s])lnıy/g, "$1льный" ],
    [ /([^\s])LNIY/g, "$1ЛЬНЫЙ" ],
    // -льняя
    [ /([^\s])lnâya/g, "$1льняя" ],
    [ /([^\s])LNÂYA/g, "$1ЛЬНЯЯ" ],
    // -льская
    [ /([^\s])lskaya/g, "$1льская" ],
    [ /([^\s])LSKAYA/g, "$1ЛЬСКАЯ" ],
    // -льский
    [ /([^\s])lskiy/g, "$1льский" ],
    [ /([^\s])LSKİY/g, "$1ЛЬСКИЙ" ],
    // -льское
    [ /([^\s])lskoye/g, "$1льское" ],
    [ /([^\s])LSKOYE/g, "$1ЛЬСКОЕ" ],
    // аббревиатуры
    // КъМДж
    [ /QMC/g, "КъМДж" ],
    // АКъШ
    [ /AQŞ([^AEI])/g, "АКъШ$1" ],
    // КъАЭ
    [ /QAE/g, "КъАЭ" ],
    // ГъСМК
    [ /ĞSMK/g, "ГъСМК" ],
    // ШСДжБ
    [ /ŞSCB/g, "ШСДжБ" ],
    // КъМШСДж
    [ /QMŞSC/g, "КъМШСДж" ],
    // КъДМПУ
    [ /QDMPU/g, "КъДМПУ" ],
    // КъМПУ
    [ /QMPU/g, "КъМПУ" ],
    // ЮШ
    [ /([\s"'\(\)\-.,:;!?>\]/])YŞ/g, "$1ЮШ" ],
    // ЮР
    [ /([\s"'\(\)\-.,:;!?>\]/])YR/g, "$1ЮР" ],
    // КъУТ
    [ /QÜT/g, "КъУТ" ],
    // 0.A. некоторые случаи употребления буквы ц
    // ц-
    [ /([\s"'\(\)\-.,:;!?>\]/])ts/g, "$1ц" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])T[sS]/g, "$1Ц" ],
    // -ц
    [ /ts([\s"'.,:;!?\)\-\[<])/g, "ц$1" ],
    [ /T[sS]([\s"'.,:;!?\)\-\[<])/g, "Ц$1" ],
    // -ци-
    [ /tsi([^zñ])/g, "ци$1" ],
    [ /T[sS][iİ]([^zZñÑ])/g, "ЦИ$1" ],
    // -цо-, -цу-
    [ /ts([ou])/g, "ц$1" ],
    [ /T[sS]([oOuU])/g, "Ц$1" ],
    // - ц согл. -
    [ /ts([bcçdfghjklmnprsştvyzBCÇDFGHJKLMNPRSŞTVYZ])/g, "ц$1" ],
    [ /T[sS]([bcçdfghjklmnprsştvyzBCÇDFGHJKLMNPRSŞTVYZ])/g, "Ц$1" ],
    // - согл. ц -
    [ /([bcçdfghjklmnprsştvzBCÇDFGHJKLMNPRSŞTVZ])ts([^iİ])([^zZñÑ])/g, "$1ц$2$3" ],
    [ /([bcçdfghjklmnprsştvzBCÇDFGHJKLMNPRSŞTVZ])T[sS]([^iİ])([^zZñÑ])/g, "$1Ц$2$3" ],
    // циал
    [ /tsиал/g, "циал" ],
    [ /TSИАЛ/g, "ЦИАЛ" ],
    [ /tsizm/g, "цизм" ],
    [ /TSİZM/g, "ЦИЗМ" ],
    [ /цın/g, "тсын" ],
    [ /ЦIN/g, "ТСЫН" ],
    [ /цız/g, "тсыз" ],
    [ /ЦIZ/g, "ТСЫЗ" ],
    // 0.B. некоторые случаи употребления буквы щ
    // щ-
    [ /([\s"'\(\)\-.,:;!?>\]/])şç/g, "$1щ" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ş[çÇ]/g, "$1Щ" ],
    // -щ
    [ /şç([\s"'.,:;!?\)\-\[<])/g, "щ$1" ],
    [ /Ş[çÇ]([\s"'.,:;!?\)\-\[<])/g, "Щ$1" ],
    // 0.C. слова на -льон
    [ /lyon/g, "льон" ],
    [ /LYON/g, "ЛЬОН" ],
    // ьи
    [ /ьi/g, "i" ],
    [ /Ьi/g, "i" ],
    [ /Ьİ/g, "İ" ],
    // 1. буквы гъ, къ, нъ, дж
    [ /ğ/g, "гъ" ],
    [ /Ğ([aâbcçdefgğhıijklmnñoöpqrsştuüvyz])/g, "Гъ$1" ],
    [ /Ğ([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZ])/g, "ГЪ$1" ],
    [ /([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZ])Ğ/g, "$1ГЪ" ],
    [ /([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZЪ])Ğ/g, "$1ГЪ" ],
    [ /q/g, "къ" ],
    [ /Q([aâbcçdefgğhıijklmnñoöpqrsştuüvyz])/g, "Къ$1" ],
    [ /Q([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZ])/g, "КЪ$1" ],
    [ /([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZ])Q/g, "$1КЪ" ],
    [ /([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZЪ])Q/g, "$1КЪ" ],
    [ /ñ/g, "нъ" ],
    [ /Ñ([aâbcçdefgğhıijklmnñoöpqrsştuüvyz])/g, "Нъ$1" ],
    [ /Ñ([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZ])/g, "НЪ$1" ],
    [ /([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZ])Ñ/g, "$1НЪ" ],
    [ /([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZЪ])Ñ/g, "$1НЪ" ],
    // 2. расставляем Ь после Л
    [ /([eiöüEİÖÜ])l([bcçdfgğhjklmnñpqrstvyz\s"'.,:;!?!\)\-\[<])/g, "$1ль$2" ],
    [ /([EİÖÜ])L([bcçdfgğhjklmnñpqrstvyzBCÇDFGĞHJKLMNÑPQRSŞTVYZ\s"'.,:;!?\)\-\[<])/g, "$1ЛЬ$2" ],
    // 3. обрабатываем ya и ye
    // ya
    [ /([bcçdfgğhjklmnñpqrsştvyzBCÇDFGĞFHJKLMNÑPQRSŞTVYZ])ya/g, "$1ья" ],
    [ /([bcçdfgğhjklmnñpqrsştvyzBCÇDFGĞFHJKLMNÑPQRSŞTVYZ])Y[aA]/g, "$1ЬЯ" ],
    [ /ya/g, "я" ],
    [ /Y[aA]/g, "Я" ],
    // ye
    [ /([bcçdfgğhjklmnñpqrsştvyzBCÇDFGĞFHJKLMNÑPQRSŞTVYZ])ye/g, "$1ье" ],
    [ /([bcçdfgğhjklmnñpqrsştvyzBCÇDFGĞFHJKLMNÑPQRSŞTVYZ])Y[eE]/g, "$1ЬЕ" ],
    [ /ye/g, "е" ],
    [ /Y[eE]/g, "Е" ],
    // 4. расставляем буквы э
    [ /([\s"'\(\)\-.,:;!?>\]//aâeıioöuüаеэяAÂEIİOÖUÜАЕЭЯ])e/g, "$1э" ],
    [ /([\s"'\(\)\-.,:;!?>\]//AÂEIİOÖUÜАЕЭЯ])E/g, "$1Э" ],
    // 5. буквы ё и ю - первый заход
    // ё
    // расставляем мягкие знаки после согласных
    [ /([\s"'\(\)\-.,:;!?>\]/])([yY])ö([çnrstzÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1$2ö$3ь$4" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])([yY])Ö([çnrstzÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1$2Ö$3Ь$4" ],
    // расставляем мягкие знаки перед ё
    [ /([bcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])y[oö]/g, "$1ьё" ],
    [ /([bcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])Y[oöOÖ]/g, "$1ЬЁ" ],
    // обрабатываем остальные вхождения ё
    [ /y[oö]/g, "ё" ],
    [ /Y[oöOÖ]/g, "Ё" ],
    [ /[yY][oöOÖ]/g, "Ё" ],
    // ю
    // расставляем мягкие знаки после согласных
    [ /([\s"'\(\)\-.,:;!?>\]/])([yY])ü([çnrstzÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1$2ü$3ь$4" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])([yY])Ü([çnrstzÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1$2Ü$3Ь$4" ],
    // расставляем мягкие знаки перед ю
    [ /([bcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])y[uü]/g, "$1ью" ],
    [ /([bcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])Y[uüUÜ]/g, "$1ЬЮ" ],
    // обрабатываем остальные вхождения ю
    [ /y[uü]/g, "ю" ],
    [ /Y[uüUÜ]/g, "Ю" ],
    [ /[yY][uüUÜ]/g, "Ю" ],
    // 6. обрабатываем bo'- bu'- и т.д. в первом слоге
    // 6.1. случаи, когда нужен мягкий знак
    // о
    [ /([\s"'\(\)\-.,:;!?>\]/])([bcgkpşBCGKPŞ])ö([çnrstzÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1$2о$3ь$4" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])([bcgkpşBCGKPŞ])Ö([çnrstzÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1$2О$3Ь$4" ],
    // у
    [ /([\s"'\(\)\-.,:;!?>\]/])([bcgkpşBCGKPŞ])ü([çnrstzÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1$2у$3ь$4" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])([bcgkpşBCGKPŞ])Ü([çnrstzÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1$2У$3Ь$4" ],
    // ьа
    [ /ьa/g, "a" ],
    [ /Ьa/g, "a" ],
    [ /ЬA/g, "A" ],
    // 6.2. случаи, когда мягкий знак не нужен
    // о
    [ /([\s"'\(\)\-.,:;!?>\]/])([bcgkmşBCGKMŞ])ö/g, "$1$2о" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])([bcgkmşBCGKMŞ])Ö/g, "$1$2О" ],
    // у
    [ /([\s"'\(\)\-.,:;!?>\]/])([bcgkmşBCGKMŞ])ü/g, "$1$2у" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])([bcgkmşBCGKMŞ])Ü/g, "$1$2У" ],
    // 7. обрабатываем o' и u' в начале слова
    // 7.1. случаи, когда мягкий знак нужен
    // о
    [ /([\s"'\(\)\-.,:;!?>\]/])ö([çnprstzÇNPRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1о$2ь$3" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ö([çnprstz])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1О$2ь$3" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ö([ÇNPRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1О$2Ь$3" ],
    // у
    [ /([\s"'\(\)\-.,:;!?>\]/])ü([çnrstzÇNRSTZ])([\s"'..,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1у$2ь$3" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ü([çnrstz])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1У$2ь$3" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ü([ÇNRSTZ])([\s"'.,:;!?\)\-\[<aAuUbcçdfgğhjklmnñpqrstvyzBCÇDFGĞFHJKLMNÑPQRSTVYZ])/g, "$1У$2Ь$3" ],
    // 7.2. случаи, когда мягкий знак не нужен
    // о
    [ /([\s"'\(\)\-.,:;!?>\]/])ö/g, "$1о" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ö/g, "$1О" ],
    // у
    [ /([\s"'\(\)\-.,:;!?>\]/])ü/g, "$1у" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Ü/g, "$1У" ],
    // 8. все оставшиеся вхождения букв a, e, o, o', u, u', y
    [ /a/g, "а" ],
    [ /A/g, "А" ],
    [ /e/g, "е" ],
    [ /E/g, "Е" ],
    [ /o/g, "о" ],
    [ /O/g, "О" ],
    [ /ö/g, "ё" ],
    [ /Ö/g, "Ё" ],
    [ /u/g, "у" ],
    [ /U/g, "У" ],
    [ /ü/g, "ю" ],
    [ /Ü/g, "Ю" ],
    [ /y/g, "й" ],
    [ /Y/g, "Й" ],
    // 9. буква c
    [ /c/g, "дж" ],
    [ /C([aâbcçdefgğhıijklmnñoöpqrsştuüvyzаеёйоуэюя])/g, "Дж$1" ],
    [ /C([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZАЕЁЙОУЭЮЯ])/g, "ДЖ$1" ],
    [ /([AÂBCÇDEFGĞHIİJKLMNÑOÖPQRSŞTUÜVYZАЕЁЙОУЭЮЯ])C/g, "$1ДЖ" ],
    // 10. все остальные буквы
    // строчные
    [ /â/g, "я" ],
    [ /b/g, "б" ],
    [ /ç/g, "ч" ],
    [ /d/g, "д" ],
    [ /f/g, "ф" ],
    [ /g/g, "г" ],
    [ /h/g, "х" ],
    [ /ı/g, "ы" ],
    [ /i/g, "и" ],
    [ /j/g, "ж" ],
    [ /k/g, "к" ],
    [ /l/g, "л" ],
    [ /m/g, "м" ],
    [ /n/g, "н" ],
    [ /p/g, "п" ],
    [ /r/g, "р" ],
    [ /s/g, "с" ],
    [ /ş/g, "ш" ],
    [ /t/g, "т" ],
    [ /v/g, "в" ],
    [ /z/g, "з" ],
    // заглавные
    [ /Â/g, "Я" ],
    [ /B/g, "Б" ],
    [ /Ç/g, "Ч" ],
    [ /D/g, "Д" ],
    [ /F/g, "Ф" ],
    [ /G/g, "Г" ],
    [ /H/g, "Х" ],
    [ /I/g, "Ы" ],
    [ /İ/g, "И" ],
    [ /J/g, "Ж" ],
    [ /K/g, "К" ],
    [ /L/g, "Л" ],
    [ /M/g, "М" ],
    [ /N/g, "Н" ],
    [ /P/g, "П" ],
    [ /R/g, "Р" ],
    [ /S/g, "С" ],
    [ /Ş/g, "Ш" ],
    [ /T/g, "Т" ],
    [ /V/g, "В" ],
    [ /V/g, "В" ],
    [ /Z/g, "З" ],
    // 11. убираем сочетания кьк, льл, ньн, рьр, сьс, тьт
    [ /кьк/g, "кк" ],
    [ /К[ьЬ]к/g, "Кк" ],
    [ /КЬК/g, "КК" ],
    [ /льл/g, "лл" ],
    [ /Л[ьЬ]л/g, "Лл" ],
    [ /ЛЬЛ/g, "ЛЛ" ],
    [ /ньн/g, "нн" ],
    [ /Н[ьЬ]н/g, "Нн" ],
    [ /НЬН/g, "НН" ],
    [ /рьр/g, "рр" ],
    [ /Р[ьЬ]р/g, "Рр" ],
    [ /РЬР/g, "РР" ],
    [ /сьс/g, "сс" ],
    [ /С[ьЬ]с/g, "Сс" ],
    [ /СЬС/g, "СС" ],
    [ /тьт/g, "тт" ],
    [ /Т[ьЬ]т/g, "Тт" ],
    [ /ТЬТ/g, "ТТ" ],
    // ьы
    [ /ьы/g, "ы" ],
    [ /Ьы/g, "ы" ],
    [ /ЬЫ/g, "Ы" ],
    // ь..ы
    [ /([^л])ь([гдклмнпрстчш])ы/g, "$1$2ы" ],
    [ /([^Л])Ь([гдклмнпрстчшГДКЛМНПРСТЧШ])ы/g, "$1$2ы" ],
    [ /([^Л])Ь([гдклмнпрстчшГДКЛМНПРСТЧШ])Ы/g, "$1$2Ы" ],
    [ /ь([гкн])ъы/g, "$1ъы" ],
    [ /Ь([ГКН])([ъЪ])ы/g, "$1$2ы" ],
    [ /Ь([ГКН])ЪЫ/g, "$1ЪЫ" ],
    // йь
    [ /йь/g, "й" ],
    [ /ЙЬ/g, "Й" ],
    [ /Йь/g, "Й" ],
    // усть
    [ /([\s"'\(\)\-.,:;!?>\]/])усьт/g, "$1уст" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])Усьт/g, "$1Уст" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])УСЬТ/g, "$1УСТ" ],
    // эки юз
    [ /эки юзь/g, "эки юз" ],
    [ /Эки юзь/g, "Эки юз" ],
    [ /ЭКИ ЮЗЬ/g, "ЭКИ ЮЗ" ],
    // учь юз
    [ /учь юзь/g, "учь юз" ],
    [ /Учь юзь/g, "Учь юз" ],
    [ /УЧЬ ЮЗЬ/g, "УЧЬ ЮЗ" ],
    // дёрт юз
    [ /дёрт юзь/g, "дёрт юз" ],
    [ /Дёрт юзь/g, "Дёрт юз" ],
    [ /ДЁРТ ЮЗЬ/g, "ДЁРТ ЮЗ" ],
    // беш юз
    [ /беш юзь/g, "беш юз" ],
    [ /Беш юзь/g, "Беш юз" ],
    [ /БЕШ ЮЗЬ/g, "БЕШ ЮЗ" ],
    // алты юз
    [ /алты юзь/g, "алты юз" ],
    [ /Алты юзь/g, "Алты юз" ],
    [ /АЛТЫ ЮЗЬ/g, "АЛТЫ ЮЗ" ],
    // еди юз
    [ /еди юзь/g, "еди юз" ],
    [ /Еди юзь/g, "Еди юз" ],
    [ /ЕДИ ЮЗЬ/g, "ЕДИ ЮЗ" ],
    // секиз юз
    [ /секиз юзь/g, "секиз юз" ],
    [ /Секиз юзь/g, "Секиз юз" ],
    [ /СЕКИЗ ЮЗЬ/g, "СЕКИЗ ЮЗ" ],
    // докъуз юз
    [ /докъуз юзь/g, "докъуз юз" ],
    [ /Докъуз юзь/g, "Докъуз юз" ],
    [ /ДОКЪУЗ ЮЗЬ/g, "ДОКЪУЗ ЮЗ" ],
    // римские цифры - временное решение проблемы
    [ /([\s"'\(\)\-.,:;!?>\]/])Ы([\s"'.,:;!?\)\-\[<])/g, "$1I$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1II$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ЫЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1III$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ЫВ([\s"'.,:;!?\)\-\[<])/g, "$1IV$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])В([\s"',:;!?\)\-\[<])/g, "$1V$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ВЫ([\s"'.,:;!?\)\-\[<])/g, "$1VI$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ВЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1VII$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ВЫЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1VIII$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])ЫX([\s"'.,:;!?\)\-\[<])/g, "$1IX$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XЫ([\s"'.,:;!?\)\-\[<])/g, "$1XI$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1XII$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XЫЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1XIII$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XЫВ([\s"'.,:;!?\)\-\[<])/g, "$1XIV$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XВ([\s"'.,:;!?\)\-\[<])/g, "$1XV$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XВЫ([\s"'.,:;!?\)\-\[<])/g, "$1XVI$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XВЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1XVII$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XВЫЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1XVIII$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XЫX([\s"'.,:;!?\)\-\[<])/g, "$1XIX$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XXЫ([\s"'.,:;!?\)\-\[<])/g, "$1XXI$2" ],
    [ /([\s"'\(\)\-.,:;!?>\]/])XXЫЫ([\s"'.,:;!?\)\-\[<])/g, "$1XXII$2" ]
]);
